"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
const react_2 = require("@emotion/react");
const accounts_1 = require("companion-app-components/flux/accounts");
const core_1 = require("companion-app-components/utils/core");
const pie_chart_svg_1 = __importDefault(require("assets/zero-state-images/pie-chart.svg"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const monthlyBarChart_1 = __importDefault(require("containers/Reports/components/monthlyBarChart"));
const selectors_1 = require("data/otReports/selectors");
const utils_1 = require("utils/date/utils");
const helpers_1 = require("../helpers");
const utils_2 = require("../utils");
const style_1 = require("./style");
const useStyles = (0, mui_1.makeStyles)()(style_1.styles);
const MonthlyData = ({ overrideMonthlyData, toolTipLabel, onBarGraphClick, isIncome, excludeCategoryInTooltip, isDashboard, }) => {
    /// State and Hooks
    const { classes } = useStyles();
    const theme = (0, react_2.useTheme)();
    const navigate = (0, react_router_1.useNavigate)();
    const [selectedMonthIndex, setSelectedMonthIndex] = (0, react_1.useState)(null);
    const dateInterval = (0, react_1.useMemo)(() => (0, utils_1.getPredefinedRange)({ value: '6_MONTHS' }), []);
    // Selectors
    const hasReportableAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state));
    const monthlyData = (0, react_redux_1.useSelector)((state) => isIncome ? (0, selectors_1.getIncomeForPeriods)(state, { dateInterval }) : (0, selectors_1.getSpendingForPeriods)(state, { dateInterval }));
    const colors = (0, react_1.useMemo)(() => (0, utils_2.getMonthlyChartColors)(isIncome, theme), [isIncome, theme]);
    const navigateToReportsWithMonth = (0, react_1.useCallback)((index) => {
        navigate((0, utils_2.getOverTimeReportRoute)(isIncome, index));
    }, [navigate, isIncome]);
    const onMonthlyBarGraphClick = (indexOfClickedMonth) => {
        if (onBarGraphClick) {
            return onBarGraphClick(indexOfClickedMonth);
        }
        setSelectedMonthIndex(indexOfClickedMonth);
        if (indexOfClickedMonth === 0 || indexOfClickedMonth) {
            core_1.tracker.track(core_1.tracker.events.barSelected, { chart: isIncome ? 'income' : 'spending' });
            setTimeout(() => {
                navigateToReportsWithMonth(indexOfClickedMonth);
            }, 1000);
        }
        return false;
    };
    const navigateToReports = (0, react_1.useCallback)((e) => {
        e.stopPropagation();
        if (!onBarGraphClick) {
            navigate((0, utils_2.getOverTimeReportRoute)(isIncome));
        }
    }, [onBarGraphClick, isIncome, navigate]);
    const dataIsNull = () => (overrideMonthlyData || monthlyData) === null;
    const dataIsEmpty = () => {
        const localmonthlyData = overrideMonthlyData || monthlyData;
        return !dataIsNull() && (0, utils_2.isMonthlyDataEmpty)(localmonthlyData);
    };
    const view = (0, helpers_1.computeViewState)(dataIsNull, dataIsEmpty, hasReportableAccounts);
    return (<div className={classes.root} role="presentation">
      {view === 'loading' && (<div className={classes.skeletonBarWrapper}>
          <Skeleton_1.default variant="rectangular" width={50} height="40%" className={classes.skeletonBarOne}/>
          <Skeleton_1.default variant="rectangular" width={50} height="50%" className={classes.skeletonBar}/>
          <Skeleton_1.default variant="rectangular" width={50} height="40%" className={classes.skeletonBar}/>
          <Skeleton_1.default variant="rectangular" width={50} height="40%" className={classes.skeletonBar}/>
          <Skeleton_1.default variant="rectangular" width={50} height="50%" className={classes.skeletonBar}/>
          <Skeleton_1.default variant="rectangular" width={50} height="60%" className={classes.skeletonBar}/>
        </div>)}
      {view === 'zero' && (<ZeroStateView_1.default icon={pie_chart_svg_1.default} onClick={navigateToReports} secondary={[
                'Sync your financial institutions to',
                <br key="br"/>,
                `see your ${isIncome ? 'income' : 'spending'} over time.`,
            ]}/>)}
      {view === 'empty' && (<ZeroStateView_1.default icon={pie_chart_svg_1.default} onClick={navigateToReports} primary={`No ${isIncome ? 'Income' : 'Spending'}`} secondary={`It looks like you haven't ${isIncome ? 'received' : 'spent'} any money in the last six months.`}/>)}
      {view === 'main' && (<monthlyBarChart_1.default idPrefix={isIncome ? 'income' : 'spending'} negator={isIncome ? 1 : -1} selectedMonthIndex={selectedMonthIndex} monthlyData={overrideMonthlyData || monthlyData} sequencedInterpolation excludeCategoryInTooltip={excludeCategoryInTooltip} onBarGraphClick={onMonthlyBarGraphClick} navigateToReports={navigateToReports} tooltipLabel={toolTipLabel || (isIncome ? 'Income' : 'Spending')} getBarAmount={(amount) => (isIncome ? amount : -amount)} colors={colors} defaultStateTransitionDuration={600} hiddenStateTransitionDuration={400} isDashboard={isDashboard}/>)}
    </div>);
};
exports.default = MonthlyData;
